import { render } from "./IconCloseFullscreen.vue?vue&type=template&id=2d1cc072"
import script from "./IconCloseFullscreen.vue?vue&type=script&lang=js"
export * from "./IconCloseFullscreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__